import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Zap, ActivitySquare, PersonStanding, Plane } from 'lucide-react';
const benefits = [{
  icon: Zap,
  title: 'Instant Relief',
  description: 'Relieves neck pain instantly'
}, {
  icon: ActivitySquare,
  title: 'Reduce Tension',
  description: 'Reduces stiffness & tension'
}, {
  icon: PersonStanding,
  title: 'Better Posture',
  description: 'Improves posture naturally'
}, {
  icon: Plane,
  title: 'Travel Friendly',
  description: 'Portable & easy to use anywhere'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BenefitsSection() {
  return <section className="bg-white py-16 lg:py-24 px-4 sm:px-6 lg:px-8" data-id="element-17">
      <div className="max-w-7xl mx-auto" data-id="element-18">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-19">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} variants={itemVariants} className="flex flex-col items-center text-center" data-id="element-20">
                <div className="bg-brand-purple-light p-4 rounded-2xl mb-5" data-id="element-21">
                  <Icon className="w-8 h-8 text-brand-purple" data-id="element-22" />
                </div>
                <h3 className="text-lg font-bold mb-2 text-brand-black" data-id="element-23">
                  {benefit.title}
                </h3>
                <p className="text-brand-gray-dark text-sm sm:text-base" data-id="element-24">
                  {benefit.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}